import { Store, ChevronRight } from "lucide-react";
import { useActivity } from "@/context/ActivityContext";

// Vue globale : pas de chiffres consolidés — l'utilisateur choisit l'activité à consulter.
export const ActivityPicker = ({ title = "Tableau de bord" }) => {
  const { activities, setCurrent } = useActivity();
  const list = (activities || []).filter((a) => !a.global && a.status !== "archived");
  return (
    <div className="space-y-4" data-testid="activity-picker">
      <div className="rounded-2xl p-5 sm:p-6 text-white shadow-lg" style={{ background: "linear-gradient(160deg,#1A3A5C 0%,#16324F 55%,#0E2135 100%)" }}>
        <div className="text-xs font-bold uppercase tracking-wider text-white/70">Vue globale</div>
        <h1 className="text-xl sm:text-2xl font-bold font-head mt-1">{title}</h1>
        <p className="text-sm text-white/80 mt-2" data-testid="activity-picker-message">Sélectionnez une activité pour consulter son tableau de bord et ses rapports.</p>
      </div>
      {list.length === 0 ? (
        <p className="text-sm text-[#64748B]" data-testid="activity-picker-empty">Aucune activité accessible.</p>
      ) : (
        <div className="grid gap-2 sm:grid-cols-2 lg:grid-cols-3">
          {list.map((a) => (
            <button key={a.id} type="button" onClick={() => setCurrent(a)} data-testid={`activity-picker-${a.id}`}
              className="card p-4 text-left flex items-center gap-3 hover:border-[#2563EB] hover:shadow-md transition-all duration-150 active:scale-[0.99]">
              <span className="w-9 h-9 rounded-xl bg-[#EFF6FF] flex items-center justify-center shrink-0"><Store className="w-4 h-4 text-[#2563EB]" /></span>
              <span className="min-w-0 flex-1">
                <span className="block font-semibold text-[#0F172A] truncate">{a.name}</span>
                <span className="block text-xs text-[#64748B] truncate">{a.template_label || a.template || "Activité"}{a.currency ? ` · ${a.currency}` : ""}</span>
              </span>
              <ChevronRight className="w-4 h-4 text-[#94A3B8] shrink-0" />
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
